import { useTranslate } from 'core/hooks/useTranslate';
import { useEffect, useState } from 'react';

export function useDialogSendNewVersion({ onSuccess, open }) {
  const { t } = useTranslate();
  const [comment, setComment] = useState('');

  useEffect(() => {
    if (open) setComment('');
  }, [open]);

  function onChangeComment(e) {
    setComment(e.currentTarget.value);
  }

  function onConfirm() {
    onSuccess(comment);
    setComment('');
  }

  return { t, comment, onChangeComment, onConfirm };
}
